import React from "react";
import { IconProps } from "../../types/types";

const DotIcon: React.FC<IconProps> = ({ size = 6, color = "#3E3EB7" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="3" r="3" fill={color} />
    </svg>
  );
};

export default DotIcon;
